import { MapperRegistryType } from './map-canvas-content.types';
import { NodeType } from '../hooks/use-sidebar-control/use-sidebar-control.types';

export const createCanvasMapperRegistry = (params: {
  mapEnrollNode: MapperRegistryType[NodeType.Enroll];
  mapWaitNode: MapperRegistryType[NodeType.Wait];
  mapActionNode: MapperRegistryType[NodeType.Action];
}): MapperRegistryType => {
  return {
    [NodeType.Enroll]: params.mapEnrollNode,
    [NodeType.Wait]: params.mapWaitNode,
    [NodeType.Action]: params.mapActionNode,
  };
};
